export default function groupDigits(value: number) {
    let output = '';
    const numeric = value.toString();
    for (let i = numeric.length - 1; i >= 0; i--) {
        const char = numeric[i];
        output = char + output;
        if ((numeric.length - i) % 3 === 0 && i > 0) {
            output = ' ' + output;
        }
    }
    return output;
}
